<script>
  export let location;
  location = location;
  export let class_id;

  import TeacherSideBar from "./TeacherSideBar.svelte";
</script>

<TeacherSideBar {class_id}>Class Data Page {class_id}</TeacherSideBar>
